import React from 'react';
import moment from 'moment';

import { Dropdown, Button } from 'antd';
import { DownOutlined, StarOutlined, StarFilled } from '@ant-design/icons';

import * as utils from '../../shared/utils';

import './styles.less';

const renderActionsMenu = (rootContainer, item, downloadBlankOriginalForm, editOriginalForm, permissions, contactType) => {
  const menuItems = [
    {
      disabled: !(utils.getPermissionsByContactType(permissions, contactType).canEdit && permissions && permissions.permissions_AcordForms.canView),
      key: 'Preview',
      onClick: () => editOriginalForm(item),
      label: 'Preview',
    },
    {
      disabled: !(permissions && permissions.permissions_AcordForms.canView),
      key: 'Download_Blank',
      onClick: () => downloadBlankOriginalForm(item.id, item.name.trim()),
      label: 'Download Blank',
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} getPopupContainer={rootContainer}>
      <Button type="primary" size="small" style={{ fontSize: '11px', padding: '2px 6px' }}>
        Actions <DownOutlined style={{ fontSize: '8px' }} />
      </Button>
    </Dropdown>
  );
};

export const getTableColumns = (rootContainer, downloadBlankOriginalForm, editOriginalForm, permissions, contactType) => {
  return [
    {
      title: '',
      width: 90,
      key: 'action',
      fixed: 'left',
      render: (text, record) => renderActionsMenu(rootContainer, record, downloadBlankOriginalForm, editOriginalForm, permissions, contactType),
    },
    {
      title: '',
      width: 10,
      key: 'favorite',
      fixed: 'left',
      render: (text, record) => <Button disabled={true} type="link" icon={record.isFavorite ? <StarFilled /> : <StarOutlined />} />,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'Change Date',
      dataIndex: 'changeDate',
      width: 200,
      sorter: true,
      key: 'changeDate',
      render: (text) => (!!text ? moment(text).format('MM/DD/YYYY') : ''),
    },
    {
      title: 'User',
      dataIndex: 'lastChangeUserName',
      key: 'lastChangeUserName',
      width: 200,
      sorter: true,
      render: (text, record) => (
        <span title={text} className="text-ellipsis-150">
          {text}
        </span>
      ),
    },
  ];
};
